export enum PuzzleGameTypesEnum {
  CrosswordPuzzle = 'swedish',
  ImagePuzzle = 'imagePuzzle',
  SudokuGame = 'sudoku',
  WordSearchPuzzle = 'wordSearchPuzzle',
  QuizGame = 'quiz',
  HashiGame = 'hashi',
}
